export default "__VITE_ASSET__24665d15__"